export function getBaseMapStyle( type ){
    let style = "dark";
    if( type == "esri_sat" || type == "globe_dark" )
        style = "light";
    return style;
}

export function getMapLayers( type ){
    if( type == "basic" )
        return ['coast','coast-h','coast-us','cntry','cntry-h','cntry-us','state','state-h','state-us','europe-state','asia-state','russia-state','america-state','island','island-us','lake','lake-us'];
    if( type == "county" )
        return ['county','county-us','county-h','county_data'];
    if( type == "city" )
        return ['city','city_data','city_data_mid','city_data_sm','city_data_xsm'];
    if( type == "highway" )
        return ['highway','highway-h','highway-us'];
    if( type == "road" )
        return ['major-road','minor-road','street'];
    if( type == "rail" )
        return ['rail'];
    if( type == "river" )
        return ['river','river-us','river-h','water-h','river-h2','water-h2','river-h3','water-h3'];
    if( type == "runway" )
        return ['airport'];
    if( type == "jetroute" )
        return ['topjetroutes','jetroutes'];
    if( type == "qroute" )
        return ['qroutes'];
    if( type == "airway" )
        return ['vairways'];
    if( type == "airspace" )
        return ['class_e','class_d','class_c','class_b'];
    if( type == "sua" )
        return ['sua_moa','sua_r','sua_data'];
    if( type == "cwarn" )
        return ['cwa','cwa_data'];
    if( type == "fir" )
        return ['fir2024','fir_data'];
    if( type == "latlon" )
        return ['latlon'];
    return [];
}

export function getRegion( name ){
    if( name == "conus" || name == "us" )
        return [ 39, -97, 4 ];
    else if( name == "northeast" || name == "ne" )
        return [ 42, -82, 5 ];
    else if( name == "southeast" || name == "se" )
        return [ 33, -88, 5 ];
    else if( name == "northcentral" || name == "nc" )
        return [ 42, -98, 5 ];
    else if( name == "southcentral" || name == "sc" )
        return [ 35, -99, 5 ];
    else if( name == "northwest" || name == "nw" )
        return [ 42, -112, 5 ];
    else if( name == "southwest" || name == "sw" )
        return [ 37, -112, 5 ];
    else if( name == "alaska" || name == "ak" )
        return [ 65, -155, 4 ];
    else if( name == "hawaii" || name == "hi" )
        return [ 21, -157, 5 ];
    else if( name == "gulfmexico" || name == "gmx" )
        return [ 25, -91, 5 ];
    else if( name == "caribbean" || name == "car" )
        return [ 15, -75, 5 ];
    else if( name == "east_carib" || name == "ecar" )
        return [ 15, -66, 6 ];
    else if( name == "europe" || name == "eur" )
        return [ 50, 15, 4 ];
    else if( name == "south_america" || name == "sam" )
        return [ -20, -55, 4 ];
    else if( name == "easia" || name == "eas" )
        return [ 35, 115, 4 ];
    else if( name == "australia" || name == "aus" )
        return [ -25, 130, 4 ];
    else if( name == "west_pacific" || name == "wp" )
        return [ 20, 140, 4 ];
    else if( name == "zab" )
        return [ 33.5, -108, 6 ];
    else if( name == "zau" )
        return [ 42, -89, 6 ];
    else if( name == "zbw" )
        return [ 43.5, -72, 6 ];
    else if( name == "zdc" )
        return [ 37, -77.5, 6 ];
    else if( name == "zdv" )
        return [ 40, -105, 5 ];
    else if( name == "zhu" )
        return [ 29.5, -96, 6 ];
    else if( name == "zfw" )
        return [ 33, -98, 6 ];
    else if( name == "zid" )
        return [ 39, -84.5, 6 ];
    else if( name == "zjx" )
        return [ 31, -83, 6 ]; 
    else if( name == "zkc" )
        return [ 38, -95, 6 ];
    else if( name == "zla" )
        return [ 34, -118, 6 ];
    else if( name == "zlc" )
        return [ 43.5, -112, 5 ];
    else if( name == "zma" )
        return [ 27, -81, 6 ];
    else if( name == "zme" )
        return [ 35, -90, 6 ];
    else if( name == "zmp" )
        return [ 44, -94, 6 ];
    else if( name == "zny" )
        return [ 38, -74, 5 ];
    else if( name == "zoa" )
        return [ 38, -122.5, 6 ];
    else if( name == "zob" )
        return [ 41, -80, 6 ];
    else if( name == "zse" )
        return [ 44.5, -122, 5 ];
    else if( name == "ztl" )
        return [ 34, -84.5, 6 ];

    return [ 39, -97, 4 ];
}

